/** Tooltips on a chip part that cannot be changed now. */
export const storyFilterChipLockedCopy = {
  drill: "Only the latest drill step can be edited.",
  drillOperator: "A drill always reads \"is\".",
  notLatest: "Only the latest step can be edited.",
} as const;

/** A personal filter's tag, and the owner's action that keeps it for everyone. */
export const storyFilterChipSharingCopy = {
  onlyYou: "Only you",
  keepForEveryone: "Keep for everyone",
} as const;
